import { render, staticRenderFns } from "./SettingsGeneral.vue?vue&type=template&id=b5bd0306&scoped=true&"
import script from "./SettingsGeneral.vue?vue&type=script&lang=js&"
export * from "./SettingsGeneral.vue?vue&type=script&lang=js&"
import style0 from "./SettingsGeneral.vue?vue&type=style&index=0&id=b5bd0306&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5bd0306",
  null
  
)

export default component.exports